var kebabCase = function(string) {
    if (string) return string.replace(/([a-z])([A-Z])/g, '$1-$2').replace(/\s+/g, '-').toLowerCase();
    return '';
};
var stringToNum = function(str) {
    return parseInt(str.replace(/\D/g, ''), 10);
};
export { kebabCase, stringToNum };
